export default __webpack_public_path__ + "static/media/hekma-logo.dbf615e6.svg";